import { apiFetch } from "../../../lib/api/client";
import { createIdempotencyKey } from "../../../lib/api/idempotency";
import type { SessionMember } from "../../../app/session/SessionProvider";
import type { LoginValues, RegisterValues } from "../schemas/authSchemas";

export interface RegistrationResult { registrationId: string; memberId: string; redirectTo: "/login" }
export interface SessionResponse { member: SessionMember }

export function registerStudent(values: RegisterValues): Promise<RegistrationResult> {
  const payload = { ...values, taxId: values.taxId || null, companyCity: values.companyCity || null, establishmentDate: values.establishmentDate || null };
  return apiFetch("/registrations", { method: "POST", headers: { "Idempotency-Key": createIdempotencyKey() }, body: JSON.stringify(payload) });
}

export function login(values: LoginValues): Promise<SessionResponse> { return apiFetch("/sessions", { method: "POST", body: JSON.stringify(values) }); }
export function logout(): Promise<void> { return apiFetch("/sessions/current", { method: "DELETE" }); }
export function requestPasswordReset(email: string): Promise<void> { return apiFetch("/password-resets", { method: "POST", body: JSON.stringify({ email }) }); }
export function resetPassword(token: string, password: string, confirmPassword: string): Promise<void> { return apiFetch(`/password-resets/${encodeURIComponent(token)}/confirm`, { method: "POST", body: JSON.stringify({ password, confirmPassword }) }); }

